import React from "react";
import { Row, Col ,Grid ,ToggleButton,ButtonToolbar,ToggleButtonGroup,Button} from 'react-bootstrap'
import Reviews from "../Reviews/Reviews";
class Copyright extends React.Component {
    
render() {
return (
<div className="copyright">
<h3> @ 2018 Dullaby. - All Rights Reserved. Designed By Anspire Agency </h3>

</div>

);
}
}
export default Copyright


// WEBPACK FOOTER //
// ./src/Components/Copyright/Copyright.jsx